
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index4tw8F_jTEOkTclsQUyoBS9USal5EZsRWlDBaDQf5gtYMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/index.vue?macro=true";
import { default as loginI07BUlemi0G_JIy1hgEVU4Pqf46mMAKLiSr54Ok67BgMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/login.vue?macro=true";
import { default as mgenAMe6bT1BMKH6iZV1fkmA8KAUPgXo7ftwVdsw59vIN68Meta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/quiz/mgen.vue?macro=true";
import { default as index7DsztzesrsVPcA4UtD_45mn_Ksxi4cE52X_umj0KYf0R4Meta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/index.vue?macro=true";
import { default as notesSKdCnGEkxwGLjXZer7JG_458h5oNjCu3yaCTMc4Y5TywAMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/notes.vue?macro=true";
import { default as indexNwr_45myf2MtRLloaQGl24Bcehhej_j1_45elio6DnX0DIEMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/stats/index.vue?macro=true";
import { default as en_45ce_45momentdCGf_45uSVCmqilpPYVIiJVreCURshSTEkn3OnV2J4lwAMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/en-ce-moment.vue?macro=true";
import { default as plan_45du_45siteixx_M6JPQrywi1YNs654c_45s0crp1hSytUeDb9IS2gjMMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/plan-du-site.vue?macro=true";
import { default as editN62pYNX0GQenUFSstGk5wr68leI4_mxe_jOSaHVE5HcMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/profile/edit.vue?macro=true";
import { default as placesw2616EikJPWt1J1pRggP0nnWByshI_Ld2LkPnb5iBEEMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/stats/places.vue?macro=true";
import { default as accessibiliteYgbnzuj4AWMpydU2lPeUBo4Z8aGaF_wnLCVcL0klpBoMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/accessibilite.vue?macro=true";
import { default as _91id_933QAwL_456amwF50CDZ6LWksplw0cqxASGZ1dEoZ5BNwOEMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/messages/[id].vue?macro=true";
import { default as notificationsFCiSbty0abgxkGXdf5FlZGXL3TQ5rspk8nO2LT6rPpIMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/notifications.vue?macro=true";
import { default as indexLQJUISx5pLi92PDwXPbN_45r_45IIL_45aRnNcis75lR13biQMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/profile/index.vue?macro=true";
import { default as indexBaNx_gZJF_RRJaoNTP9rYsrprRKK3bVKyWPlzqz_45GQEMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/support/index.vue?macro=true";
import { default as _91slug_937SqaHuTpubVa1UZnx2l2tw0qE6NA0AyjGOaKCkguJpAMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/villes/[slug].vue?macro=true";
import { default as index2iXP7wVPZJ7yE9DYsC9Do0aggRzJ57jehKE8fWBGFqoMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/messages/index.vue?macro=true";
import { default as generiqueH7xFRRjyvqJUBwcGinLVA0VzTnozCpHqBYmDIjFbHNUMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/quiz/generique.vue?macro=true";
import { default as _91slug_93mQJQjMgqpiOtD7IxRr9m8M4TN9_ux3lOayDZbcoALlkMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/reseaux/[slug].vue?macro=true";
import { default as missionsy_45NPFVZ1SqxtwdFpG0m_XSdVXAx0fM9_45m82lZZb_45ESwMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/stats/missions.vue?macro=true";
import { default as index3_QUBW_Ck1MJGWBI6OezgdWD8aYPwNoEdWZBjLFIlZcMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/dashboard/index.vue?macro=true";
import { default as favorisB65G4T2NmPC6kmC1zbpbIs_45a6BJ3sNdp7Iq5_3eCTQgMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/profile/favoris.vue?macro=true";
import { default as _91slug_93rVywkwttzR_rKz6xXAM9cIK8mfIRZ6K3lUaY9MzLoTcMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/activites/[slug].vue?macro=true";
import { default as logsiPWnrtenn0XXQ3XXUPxJ3lI_450fP_ipSRUUTbPjKFkHEMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/other/logs.vue?macro=true";
import { default as ressourcesaSCmnsUBtwBbIVmwZ1VTR_XUgck29Uzhs_GODOJWo6AMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/ressources.vue?macro=true";
import { default as mentions_45legalesWKmAWsZLnCuqSCclnrHcg_45_7n22D4BrS4pUzMQboLjEMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/mentions-legales.vue?macro=true";
import { default as missionseFRSPebc1RBNloJ2tw5UjILqHq9sHaogm3JReGkegzkMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/profile/missions.vue?macro=true";
import { default as settingssbmAjjpB54gR1OLoTTlcgJWopS2yn7WwbEb7Dk8_ewMMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/profile/settings.vue?macro=true";
import { default as tournee_45eteKZP1AlZB3mDPau0qlg7ofO1ooZnL9uwr4miYKk2S8_YMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/quiz/tournee-ete.vue?macro=true";
import { default as temoignagesfifP0KgFYPKNCt7wACMj2zDLtNw8CQ0ry6LqzAuBtmoMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/temoignages.vue?macro=true";
import { default as indexxWjni5jNrGyf_K_45ZgvTrPTSHAr_xKE15q3iOrpJlNg0Meta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/inscription/index.vue?macro=true";
import { default as adminry4TKmbeuxZFsEyI8XR_MPE3_V3aLeMEtMXSpoC2S_45MMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/maintenance/admin.vue?macro=true";
import { default as indexF1z85TcsJhF73Z63Zm1r9Hs7OgTYDFKwfOOtQ854JF8Meta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/maintenance/index.vue?macro=true";
import { default as indexc0ehBOP9A5volC1IO4H2tCar5kRjDITg19s0FlaPYfUMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/territoires/index.vue?macro=true";
import { default as _91hash_93QhYDnxD1MzioXcKzewnOB23hyvgWmBDSc9A32KlVqlYMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/invitations/[hash].vue?macro=true";
import { default as utilisateursyVJC_PCxGsaog7jpUMQQXmJWKLCUB7Kb5zVGz0YQh5MMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/stats/utilisateurs.vue?macro=true";
import { default as _91slug_93bibmDa8cKXrFluz3qyIvcx4HppiHJ6SMCOp7Z8KDeaUMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/associations/[slug].vue?macro=true";
import { default as _91slug_93hALUMS06dzU66WzlVleFtDaRFm2ZJBYvjegjWmm79iUMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/departements/[slug].vue?macro=true";
import { default as indexmQbRMc_45mKX_45l2XfrjsoBrU_Tzm0afW3Udjwh28rLAFkMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/organisations/index.vue?macro=true";
import { default as preferencesFPDAa1ZCYSbcAQax0It2bqAqntcAPWNz21RC_45_qf8isMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/profile/preferences.vue?macro=true";
import { default as organisationsMxTACfikeOn_457U2HC47SzTP78ZEBslma_45v5dIEGXKB0Meta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/stats/organisations.vue?macro=true";
import { default as _91token_93yLj7zyhEvqYrcWZX2Wq8vz7pKxtweGzbvkvgtb_45hH7AMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/temoignages/[token].vue?macro=true";
import { default as postsAfqzdnVWTEUwxo_45h2Ohfcc_45OrTcqee4vqbOawBClTLgMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/posts.vue?macro=true";
import { default as index1HsxODKLQyxag88vlnErmbGU2dFgF4ZVCbJdjH7RopMMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/missions/index.vue?macro=true";
import { default as add9GrrTXi2ZxEtKQZAz9v6zUWLvR_RwwUT3RnTSyCuvhcMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/messages/modeles/add.vue?macro=true";
import { default as _91slug_93efZorytBbz8h2Jkd5Kch_45cqiietNqCwLlDkx65SPp7YMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/organisations/[slug].vue?macro=true";
import { default as indexWnKqsE8yyUochdD4m9LKATzLV1PbQDJ2_45GslV_450YdZQMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/password-reset/index.vue?macro=true";
import { default as participationsGtStzpHoz0TV07fjRq7A3InddIiEmrDPCRdrGadbahsMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/stats/participations.vue?macro=true";
import { default as emailsNh8I89HPI30q9fJ1SuKOhOaXdU6eqwxBC0VaAGzu6xwMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/settings/emails.vue?macro=true";
import { default as indexMx21hDe5hj6Pnt4M5CCgxwDBLPyC6_RcWyLc5imf_45R0Meta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/profile/alertes/index.vue?macro=true";
import { default as notificationsLMmq0FxCLVSUyPvW552rc_45xgxYrUOI9pZngjt5W4ptUMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/profile/notifications.vue?macro=true";
import { default as index05HIgPZeD1XMbI_VLQE2DDpbufFVF8hYzjQ73SbxQyMMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/statistics/index.vue?macro=true";
import { default as charte_45reserve_45civiqueKrCdp0H880iDIQk4dVM3PZw6uauu4lv0FFvVYJo5HnYMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/charte-reserve-civique.vue?macro=true";
import { default as _91slug_93ZBma6_HnnxjWmd11DvDF0L0Ocmb_1YpULumo6cysRG0Meta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/domaines-action/[slug].vue?macro=true";
import { default as indexxN8RexZbTyVM_451_45t8S6huRu_45rejE8xVCqsYr3N0AeYMMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/messages/modeles/index.vue?macro=true";
import { default as _91token_93VJse0biQqRLCDJ4x0LzhhXTkxWto69dVFAr_kabawjAMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/password-reset/[token].vue?macro=true";
import { default as decembre_45ensemble7es9jDqmIWUwZl6Grx_45VDdXc3PchKkw2Awhm7_AebWcMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/quiz/decembre-ensemble.vue?macro=true";
import { default as invitationskxk5vUIOBQohonBV8trlYs5f_o6Wyoet0PCimr4VrOMMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/other/invitations.vue?macro=true";
import { default as messagesnTSswVZ4_45BrlUtaskKk_458l9VXmDhqswNpJw8EXQ72j0Meta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/settings/messages.vue?macro=true";
import { default as places7PZ1afKQ_8TlqcNRfMKqt6wdHcYVBqvyvd5yDqMBY_45cMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/statistics/places.vue?macro=true";
import { default as addn816hfiOzFZt2Ldn4LFAoCIHjYWGgprfU5ZLoa5X2hEMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/settings/rules/add.vue?macro=true";
import { default as indexd7boL_45p8oECzEvGX1dNnDFimmCkrg1fBiratXxiweswMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/utilisateurs/index.vue?macro=true";
import { default as indexd60p6nQ43Ijnc1g8Y4iX1KV1aFTsve908KZI4ZjxTSwMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/missions-benevolat/index.vue?macro=true";
import { default as dateslF42hHlRJYMJ8KXTxk0p1nSvl3L5ZAiiW3Af7taF9z4Meta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/missions/[id]/dates.vue?macro=true";
import { default as index0NxaC3MwL8y4OCPTTEi2HFaqmT4Fhi__45_V9fJO_45_45p6MMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/missions/[id]/index.vue?macro=true";
import { default as lieuxew50FW_Gg74SoaSfBcxY94fjqELjoD02bR6CoFVl9f8Meta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/missions/[id]/lieux.vue?macro=true";
import { default as titlei9fM1MXhEWJ0GcLHqjzGhCrEMTEBuZ6N2k2fR9M7xnoMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/missions/[id]/title.vue?macro=true";
import { default as indexha9RFttrcEeAJGnSrZGuXSRv2_bG8ub33JXAVJnBYCIMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/organisations/index.vue?macro=true";
import { default as missionshWKXKhW0zH3Tven8CZj2pB2reTWhzr2XvPuWtVEU_452kMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/statistics/missions.vue?macro=true";
import { default as addPEM_4576QojO9HAoTltR8XP0xhBs4NsPdwYkbs9qsCmvsMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/reseaux/add.vue?macro=true";
import { default as visuelxI7_fU3PUQVxDq_FveeLrKA5UaNSN80Pb2hfYNxjRCkMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/missions/[id]/visuel.vue?macro=true";
import { default as indexciyhAj7MEgIVJxlJBRPUMaNnxEjF9pJ61c0yi1WbRKMMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/participations/index.vue?macro=true";
import { default as indexP4UUAWPjz_kx_DFAWZiuXZZn_iffYhS_yKviJlj1mLgMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/settings/rules/index.vue?macro=true";
import { default as index87304XIGHyxXTHXZYOR70dvRpdeJQt92K8bkAGqBP10Meta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/inscription/benevole/index.vue?macro=true";
import { default as add396tO9fvrWnEgjSuvMuVFIxqeIL73ztX4KQdEdqSLEcMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/domaines/add.vue?macro=true";
import { default as add_hT5GnXWR1VdM8g6N2kCDiQEvhnSXo6NXzh5oNBYGWUMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/taxonomies/[slug]/add.vue?macro=true";
import { default as addBQzrgcWTNH_yltKpMlblaMONbDDb98wUeoSaT9ao3OIMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/activites/add.vue?macro=true";
import { default as indexT8NxA7JnCdcS6LOWCD_nqKvX7ynh5W_45DEwONO4QGZgMMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/reseaux/index.vue?macro=true";
import { default as conversionsKZp6NEVG9S8bLS9M14zCzfGV0SZ0Se8x86brBPfnnd8Meta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/statistics/conversions.vue?macro=true";
import { default as editojZZBRTLfdMzGnZ4Nr6O_45nBwiC61SfSCFx_45w6GvVGdAMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/utilisateurs/[id]/edit.vue?macro=true";
import { default as politique_45de_45confidentialiteVziSwZWifMm5zkweDkx0RNvJCCWddSU7W6Hn9XMkQwQMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/politique-de-confidentialite.vue?macro=true";
import { default as indexsG7X_45kSxTYJZbX345DZANKp8PHPjdGnUZRoR_3KQNXwMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/domaines/index.vue?macro=true";
import { default as add4FGoCnFUSxS2NfvcWdIsn7iEORAhG1hC8Qi7VCHUiNwMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/ressources/add.vue?macro=true";
import { default as benevolesJWRnMuI2zm7_45Sj1C4gpWwf9UY7Fllv1_gvk2TbPZN4kMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/missions/[id]/benevoles.vue?macro=true";
import { default as editxkpE_45jvSOWhpC43jtkQnej5kuv3Y5XupW_45GPnYAnOt0Meta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/organisations/[id]/edit.vue?macro=true";
import { default as utilisateurs1q8jaQhXZ9RvWOK_45sUkqSO1yF1lwYOARu_7fFGH_45iooMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/statistics/utilisateurs.vue?macro=true";
import { default as index_SuuiuGmv_We45JJJkjyK9CYTeSlWlzPj_rWgdWtXJUMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/taxonomies/[slug]/index.vue?macro=true";
import { default as indexrroORRt6Megfc2T4yCw7s6wfxjnAakcrd1HOQMkoWL8Meta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/utilisateurs/[id]/index.vue?macro=true";
import { default as indexISITqOeXrZSlQoybXEfof0gntDhR_45VZrxurgXcq0psIMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/inscription/responsable/index.vue?macro=true";
import { default as indexKlXS89uIEyCDC62IwzAv__UK_45cM4C6hZME0mchKNMl0Meta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/missions-benevolat/[id]/index.vue?macro=true";
import { default as septembre_45pour_45apprendredZUBnBt71xi9YnMf06cIRYMz8ZEhnSilF9y1QCOxHSUMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/quiz/septembre-pour-apprendre.vue?macro=true";
import { default as indexaWGzkQTCESgPbD_45BUsi4AnZzWuRicOvIlneIS3z6ACoMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/activites/index.vue?macro=true";
import { default as add5hLpmiwXhemusHWzv8hSEJ8gLqVX95_45pbRmTgkzuqk4Meta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/territoires/add.vue?macro=true";
import { default as indexLL7p_45Syw_45KNAaSM9yQye0VG2qoDt57ToyFZa_vGsCYAMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/organisations/[id]/index.vue?macro=true";
import { default as editcqPQ9KXEFFdc_lI3Ba2vyGQgioJmQM5oAcIyBd7mSUIMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/settings/rules/[id]/edit.vue?macro=true";
import { default as _91slug_935_45rESps8LyGtp_i997MEpzYhexwsg5Rf29Q2SuGmcecMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/missions-benevolat/[id]/[slug].vue?macro=true";
import { default as printemps_45pour_45la_45planetemHa7aaDNi7vEfJkVadNwjBP9349zguq_45w_45xhf8xtchIMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/quiz/printemps-pour-la-planete.vue?macro=true";
import { default as indexAbdmxiE3L4_boWXffJBSMfIEb_xTiH3Dv_45moBzgVnIcMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/ressources/index.vue?macro=true";
import { default as participationsxkxFt9nrhxSdW9QJbj0oagFWUlM59o7DCXtNesXx2_gMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/statistics/participations.vue?macro=true";
import { default as indexw6lk96ckoURxvBsIpgpC5yn3j7khswb6imx7thLnh3oMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/charte-bon-fonctionnement/index.vue?macro=true";
import { default as activity_45logs42ZEPruLAp9CImWpSJosjiVGgkcPGNOzIbL5juYKEeAMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/support/referents/activity-logs.vue?macro=true";
import { default as editY0_I_tJuCrpgmSpR_qIAJ7bpqJzTWsrPL_6XOzYA488Meta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/reseaux/[id]/edit.vue?macro=true";
import { default as indexrHOT9xcrEN_45ryhWARQaRyjb_458qSQM_45VnU6fFDnY3VWkMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/territoires/index.vue?macro=true";
import { default as informationsVMPhaHkKvn_45DnvuRLquOFVXwwNzmG1XWKn1HjlzBgcAMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/missions/[id]/informations.vue?macro=true";
import { default as responsablesRE9hBVYN9T6jm9jzAoYTFL_45Isk_U_45eGxCLz8pNiq_452oMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/missions/[id]/responsables.vue?macro=true";
import { default as editBmjY4ZzV_45UFcpsIknhMh13QkFksgfila6lYboKoZWEMMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/domaines/[id]/edit.vue?macro=true";
import { default as indexqW8I_45ROSx6FgHwDxTyBT7Ly_45M4tELugiDuXEGZiDT5QMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/reseaux/[id]/index.vue?macro=true";
import { default as indexHw7AkVPOnBoJ_45lXfKzRZEZk4dXCKOTgGLx00FwqTRC4Meta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/testimonials/index.vue?macro=true";
import { default as indicateurs_45clesmKDJj4LbJ2Wn_9PR_8KpQd8BswcAoR_45wrJDPlds3McwMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/statistics/indicateurs-cles.vue?macro=true";
import { default as editaoxm9AGfxxhUVu5EaHhr864bhfmMfy_45tME_459E6FXBegMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/taxonomies/[slug]/[id]/edit.vue?macro=true";
import { default as profilemtNzuMIjBtwg_45MXiJzBb0DU0HyTnHXV7pNjXEyXCrOwMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/inscription/benevole/step/profile.vue?macro=true";
import { default as charte_45bon_45fonctionnementSxiDQQZbEw_dfzeKgj4tou2cCzlFMIKfOhTDeeAh6lMMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/profile/charte-bon-fonctionnement.vue?macro=true";
import { default as waiting_45actionsSd_ThVrkTVNKgvmFNutlwrcqpZkKH2M7n2UwBA7veqsMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/support/referents/waiting-actions.vue?macro=true";
import { default as editPIBduzjZVcmaA8_d9Ps_yCU7PjseOSJ3gtjZy0gEBLgMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/activites/[id]/edit.vue?macro=true";
import { default as addxHtq_45eXB0wna2fwbgkDpRI0sNF7TimLicKSfpP1mTTgMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/modeles-mission/add.vue?macro=true";
import { default as conditions_45generales_45d_45utilisationSMRMSCSt_HUFXntOeqkjCTA7Mn2vxaDmqToidiobjQ4Meta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/conditions-generales-d-utilisation.vue?macro=true";
import { default as indexkx1sKS5tRH_45dwveFrOUgoHILyp7F8kvofU9UvWAbvXgMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/activites/[id]/index.vue?macro=true";
import { default as editkX58IZNYlaUfbOgXePPwE6ti_RJjy5K0RbJkjjWPa5QMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/ressources/[id]/edit.vue?macro=true";
import { default as diffusions_83o6URkb1zl2COz8qkrlOUaC2CK4keaFvm_5NlK9yoMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/organisations/[id]/diffusions.vue?macro=true";
import { default as moderations8BkXhiQZDW21n4AfjkqxlUC_yAAWFm6p35OKvhidjrEMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/statistics/suivis/moderations.vue?macro=true";
import { default as benevolesT1EUkoBFtFf8y4FSmPkskrXMpW6iNq4F3YIer2iJrpcMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/charte-bon-fonctionnement/benevoles.vue?macro=true";
import { default as google_45api_45indexingXl7AvDRxk10XclELaHEobDaX3Arz58HO25bIpETRIHQMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/support/actions/google-api-indexing.vue?macro=true";
import { default as indexZeLYClFHKnJcytadmOdkcSx4ONKrov9SpL6nQyXk9kgMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/modeles-mission/index.vue?macro=true";
import { default as editRWzdoDX90EpC2tVyzQ4RtFwVfbjJXuUgOn602VrcAgwMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/territoires/[id]/edit.vue?macro=true";
import { default as indext_Y2WocQKt6DQglu5b0W_45dJU3g0C1nRtpRORBU7Q6HgMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/statistics/organisations/index.vue?macro=true";
import { default as profileU0_Ep__45Hvl2LFZUOFUTlv2a7a4labeyEpedFFnfzQNIMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/inscription/responsable/step/profile.vue?macro=true";
import { default as indexsF86fwvO9TUrx7nSMZibnDuqjvKd2Xn4uTr6b9IQLGcMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/territoires/[id]/index.vue?macro=true";
import { default as editTq4JXvo0UpLH2n9h2gC5VUbAF8lr_hcNgXR52Pm_45vyMMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/testimonials/[id]/edit.vue?macro=true";
import { default as adde4iCsewqD5Vga5U6zT8SFY68uGdOXpyGva7EUYyuqRgMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/organisations/[id]/missions/add.vue?macro=true";
import { default as competencesV8TWNWopydQNK2rpppd4KX9HFmhjM4yrm37lBVmtUPsMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/inscription/benevole/step/competences.vue?macro=true";
import { default as preferencesxVbkGusNttmGBYnzBGbLIEldSaXW_4aruD1_45M6BFbvcMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/inscription/benevole/step/preferences.vue?macro=true";
import { default as search_45archived_45usersypgdFycA_b7pOxqL2C_45ynmVmCGkYdywxffsApNy8IgYMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/support/actions/search-archived-users.vue?macro=true";
import { default as doublons_45territoiresc2g_45FzPSHg8LKiPxp6acXmt9_tH5EnIWCrKDNUMP3BsMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/support/contents/doublons-territoires.vue?macro=true";
import { default as responsablesoMYm16PTO_9XvFYwQx8X__45rmXFO7eQ_5mZOQTpsXnJUMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/charte-bon-fonctionnement/responsables.vue?macro=true";
import { default as transfert_45organisation9UbMZM0E6erB_455bdldya_4567Qn_qoVZXsW2VHMkpCGAEMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/support/actions/transfert-organisation.vue?macro=true";
import { default as missions_45outdatedHTo6UIqv8_gHqS2wAX1LiTHFrbuKhOPIpzqJKwrAcWwMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/support/responsables/missions-outdated.vue?macro=true";
import { default as pending_45itemsRqKqWBqMBCW4j3fVYs_45ZxTRYWNYGqykq5Gwttb_9YAQMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/settings/rules/[id]/pending-items.vue?macro=true";
import { default as user_45reset_45context_45role7azn6qyLRXXo58h8KtIOXjec3OKqrCBpcdEr6SeuRs4Meta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/support/actions/user-reset-context-role.vue?macro=true";
import { default as doublons_45organisations_45_dul9Sv15uMs8t0qbDkmfUNQlLd8VqnEVS55bldvlYMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/support/contents/doublons-organisations.vue?macro=true";
import { default as edit5N4biuHg7EM9O6axSDxj5wZmeo201kINuBk9cYUv86oMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/modeles-mission/[id]/edit.vue?macro=true";
import { default as disponibilites35OXRtdhwvM9QKsMWqyzZZvKNdNFb4_SrEjyRUsui2sMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/inscription/benevole/step/disponibilites.vue?macro=true";
import { default as user_45reset_45password_45linkpWta_458H4xIzkq04t0eEBJisnSySB6L_QsdH3ZmwKAE8Meta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/support/actions/user-reset-password-link.vue?macro=true";
import { default as index_MNXNvkrpkK_45V7euwrSQshYbku9tRLJ4FszMBDEBc2QMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/modeles-mission/[id]/index.vue?macro=true";
import { default as collectivitexMvTOV3eijcQw_UkBDhgSycKv6KqNZZYhRbF5iCSIDIMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/inscription/responsable/step/collectivite.vue?macro=true";
import { default as organisation9jT5GSfts3uusjt8HmfTWI3d78b2_qp3NFseU58ue9oMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/inscription/responsable/step/organisation.vue?macro=true";
import { default as benevoles_45informationsS3wctyIGoEv4CuFCr6G8OrP2S1EFG9i9m4J4F71TXcUMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/missions/[id]/benevoles-informations.vue?macro=true";
import { default as trafic_45entrantwzTgawCmOjSVPnUwvwD3z2THtFwbeVaHwSqJOVfKeh0Meta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/statistics/api-engagement/trafic-entrant.vue?macro=true";
import { default as trafic_45sortantcyOjMZ6_45LmZy9xncq79x39miPhvAe_riOkTop0f08A4Meta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/statistics/api-engagement/trafic-sortant.vue?macro=true";
import { default as indexqJR4ZYleIQxIXbDvYk7PIzoN3hyjOemuixJJDtH63hMMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/missions/[id]/trouver-des-benevoles/index.vue?macro=true";
import { default as missions_45perimeesoU_45KRw4WxNo7HsbT689nGcRUNjw9T9raSEIX7bcLoMYMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/statistics/departements/missions-perimees.vue?macro=true";
import { default as missions_45a_45valider2N8ThHP2JBgVcddgPbk6gjihBZkI_45jMoJ6EQVIyPrJUMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/statistics/departements/missions-a-valider.vue?macro=true";
import { default as missions_45perimeesiOs5diL9OsP9IeLjdS1Wf0Zgw5VSwqmuvuu3BwlpDcYMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/statistics/organisations/missions-perimees.vue?macro=true";
import { default as organisation_45imagese5Vw583atV_ph1TQCwNXwvda5nl0E5VAyFoe4rc2waUMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/inscription/responsable/step/organisation-images.vue?macro=true";
import { default as organisation_45detailsfZbRhj5h25eyZI3tTSCEVR9J2yERqaFQHbb2xvQV6jgMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/inscription/responsable/step/organisation-details.vue?macro=true";
import { default as participations_45to_45be_45treatedhq6PfO1w_45UVcdzwugTZAA6RKSQ8ZdHq7oJYyd6_456_B8Meta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/support/responsables/participations-to-be-treated.vue?macro=true";
import { default as redirectDJqYjv1dpIFrSsBeB4XhwfavBB3723wfuIDvT8iT7UEMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/missions/[id]/trouver-des-benevoles/redirect.vue?macro=true";
import { default as organisations_45a_45validerjXIvQOzT7JFzFPyy9vMgmnNBkLWp_45_ZXVku1vr0zb7oMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/statistics/departements/organisations-a-valider.vue?macro=true";
import { default as charte_45bon_45fonctionnementVNSZiU1LMnXneNC1e_456gOO3o18Jnjindv5BTutpOXGkMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/inscription/responsable/step/charte-bon-fonctionnement.vue?macro=true";
import { default as collectivite_45confirmationkxsl_DI4GnWWYkG95_TsZpwT5c3O91hXTVCinFjK0fcMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/inscription/responsable/step/collectivite-confirmation.vue?macro=true";
import { default as organisation_45confirmationcgaUVwxXgUuqIgpNce_45vKlDxu1DxclgyxlXoz17U3bgMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/inscription/responsable/step/organisation-confirmation.vue?macro=true";
import { default as participations_45a_45valider6nlUKsE6JDwE_45FLBu7TjFvAI_45mQddGruL66_tzSZGeQMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/statistics/organisations/participations-a-valider.vue?macro=true";
import { default as participations_45refusees_45annuleesrlVY2Z7G1kD6loWnMdqYYyBsQVVSoplikesPKN2EW5YMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/statistics/organisations/participations-refusees-annulees.vue?macro=true";
import { default as component_45stub32ei5Lp6kKFMxeAtTr0nOthwUtOReReQnZ7RRfSB07IMeta } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub32ei5Lp6kKFMxeAtTr0nOthwUtOReReQnZ7RRfSB07I } from "/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginI07BUlemi0G_JIy1hgEVU4Pqf46mMAKLiSr54Ok67BgMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/login.vue")
  },
  {
    name: "quiz-mgen",
    path: "/quiz/mgen",
    meta: mgenAMe6bT1BMKH6iZV1fkmA8KAUPgXo7ftwVdsw59vIN68Meta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/quiz/mgen.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: index7DsztzesrsVPcA4UtD_45mn_Ksxi4cE52X_umj0KYf0R4Meta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/index.vue")
  },
  {
    name: "admin-notes",
    path: "/admin/notes",
    meta: notesSKdCnGEkxwGLjXZer7JG_458h5oNjCu3yaCTMc4Y5TywAMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/notes.vue")
  },
  {
    name: "stats",
    path: "/stats",
    meta: indexNwr_45myf2MtRLloaQGl24Bcehhej_j1_45elio6DnX0DIEMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/stats/index.vue")
  },
  {
    name: "en-ce-moment",
    path: "/en-ce-moment",
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/en-ce-moment.vue")
  },
  {
    name: "plan-du-site",
    path: "/plan-du-site",
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/plan-du-site.vue")
  },
  {
    name: "profile-edit",
    path: "/profile/edit",
    meta: editN62pYNX0GQenUFSstGk5wr68leI4_mxe_jOSaHVE5HcMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/profile/edit.vue")
  },
  {
    name: "stats-places",
    path: "/stats/places",
    meta: placesw2616EikJPWt1J1pRggP0nnWByshI_Ld2LkPnb5iBEEMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/stats/places.vue")
  },
  {
    name: "accessibilite",
    path: "/accessibilite",
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/accessibilite.vue")
  },
  {
    name: "messages-id",
    path: "/messages/:id()",
    meta: _91id_933QAwL_456amwF50CDZ6LWksplw0cqxASGZ1dEoZ5BNwOEMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/messages/[id].vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: notificationsFCiSbty0abgxkGXdf5FlZGXL3TQ5rspk8nO2LT6rPpIMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/notifications.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: indexLQJUISx5pLi92PDwXPbN_45r_45IIL_45aRnNcis75lR13biQMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/profile/index.vue")
  },
  {
    name: "support",
    path: "/support",
    meta: indexBaNx_gZJF_RRJaoNTP9rYsrprRKK3bVKyWPlzqz_45GQEMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/support/index.vue")
  },
  {
    name: "villes-slug",
    path: "/villes/:slug()",
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/villes/[slug].vue")
  },
  {
    name: "messages",
    path: "/messages",
    meta: index2iXP7wVPZJ7yE9DYsC9Do0aggRzJ57jehKE8fWBGFqoMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/messages/index.vue")
  },
  {
    name: "quiz-generique",
    path: "/quiz/generique",
    meta: generiqueH7xFRRjyvqJUBwcGinLVA0VzTnozCpHqBYmDIjFbHNUMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/quiz/generique.vue")
  },
  {
    name: "reseaux-slug",
    path: "/reseaux/:slug()",
    meta: _91slug_93mQJQjMgqpiOtD7IxRr9m8M4TN9_ux3lOayDZbcoALlkMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/reseaux/[slug].vue")
  },
  {
    name: "stats-missions",
    path: "/stats/missions",
    meta: missionsy_45NPFVZ1SqxtwdFpG0m_XSdVXAx0fM9_45m82lZZb_45ESwMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/stats/missions.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: index3_QUBW_Ck1MJGWBI6OezgdWD8aYPwNoEdWZBjLFIlZcMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/dashboard/index.vue")
  },
  {
    name: "profile-favoris",
    path: "/profile/favoris",
    meta: favorisB65G4T2NmPC6kmC1zbpbIs_45a6BJ3sNdp7Iq5_3eCTQgMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/profile/favoris.vue")
  },
  {
    name: "activites-slug",
    path: "/activites/:slug()",
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/activites/[slug].vue")
  },
  {
    name: "admin-other-logs",
    path: "/admin/other/logs",
    meta: logsiPWnrtenn0XXQ3XXUPxJ3lI_450fP_ipSRUUTbPjKFkHEMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/other/logs.vue")
  },
  {
    name: "admin-ressources",
    path: "/admin/ressources",
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/ressources.vue")
  },
  {
    name: "mentions-legales",
    path: "/mentions-legales",
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/mentions-legales.vue")
  },
  {
    name: "profile-missions",
    path: "/profile/missions",
    meta: missionseFRSPebc1RBNloJ2tw5UjILqHq9sHaogm3JReGkegzkMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/profile/missions.vue")
  },
  {
    name: "profile-settings",
    path: "/profile/settings",
    meta: settingssbmAjjpB54gR1OLoTTlcgJWopS2yn7WwbEb7Dk8_ewMMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/profile/settings.vue")
  },
  {
    name: "quiz-tournee-ete",
    path: "/quiz/tournee-ete",
    meta: tournee_45eteKZP1AlZB3mDPau0qlg7ofO1ooZnL9uwr4miYKk2S8_YMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/quiz/tournee-ete.vue")
  },
  {
    name: "admin-temoignages",
    path: "/admin/temoignages",
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/temoignages.vue")
  },
  {
    name: "inscription",
    path: "/inscription",
    meta: indexxWjni5jNrGyf_K_45ZgvTrPTSHAr_xKE15q3iOrpJlNg0Meta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/inscription/index.vue")
  },
  {
    name: "maintenance-admin",
    path: "/maintenance/admin",
    meta: adminry4TKmbeuxZFsEyI8XR_MPE3_V3aLeMEtMXSpoC2S_45MMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/maintenance/admin.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: indexF1z85TcsJhF73Z63Zm1r9Hs7OgTYDFKwfOOtQ854JF8Meta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/maintenance/index.vue")
  },
  {
    name: "territoires",
    path: "/territoires",
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/territoires/index.vue")
  },
  {
    name: "invitations-hash",
    path: "/invitations/:hash()",
    meta: _91hash_93QhYDnxD1MzioXcKzewnOB23hyvgWmBDSc9A32KlVqlYMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/invitations/[hash].vue")
  },
  {
    name: "stats-utilisateurs",
    path: "/stats/utilisateurs",
    meta: utilisateursyVJC_PCxGsaog7jpUMQQXmJWKLCUB7Kb5zVGz0YQh5MMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/stats/utilisateurs.vue")
  },
  {
    name: "associations-slug",
    path: "/associations/:slug()",
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/associations/[slug].vue")
  },
  {
    name: "departements-slug",
    path: "/departements/:slug()",
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/departements/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/organisations/index.vue")
  },
  {
    name: "profile-preferences",
    path: "/profile/preferences",
    meta: preferencesFPDAa1ZCYSbcAQax0It2bqAqntcAPWNz21RC_45_qf8isMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/profile/preferences.vue")
  },
  {
    name: "stats-organisations",
    path: "/stats/organisations",
    meta: organisationsMxTACfikeOn_457U2HC47SzTP78ZEBslma_45v5dIEGXKB0Meta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/stats/organisations.vue")
  },
  {
    name: "temoignages-token",
    path: "/temoignages/:token()",
    meta: _91token_93yLj7zyhEvqYrcWZX2Wq8vz7pKxtweGzbvkvgtb_45hH7AMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/temoignages/[token].vue")
  },
  {
    name: "admin-contenus-posts",
    path: "/admin/contenus/posts",
    meta: postsAfqzdnVWTEUwxo_45h2Ohfcc_45OrTcqee4vqbOawBClTLgMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/posts.vue")
  },
  {
    name: "admin-missions",
    path: "/admin/missions",
    meta: index1HsxODKLQyxag88vlnErmbGU2dFgF4ZVCbJdjH7RopMMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/missions/index.vue")
  },
  {
    name: "messages-modeles-add",
    path: "/messages/modeles/add",
    meta: add9GrrTXi2ZxEtKQZAz9v6zUWLvR_RwwUT3RnTSyCuvhcMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/messages/modeles/add.vue")
  },
  {
    name: "organisations-slug",
    path: "/organisations/:slug()",
    meta: _91slug_93efZorytBbz8h2Jkd5Kch_45cqiietNqCwLlDkx65SPp7YMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/organisations/[slug].vue")
  },
  {
    name: "password-reset",
    path: "/password-reset",
    meta: indexWnKqsE8yyUochdD4m9LKATzLV1PbQDJ2_45GslV_450YdZQMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/password-reset/index.vue")
  },
  {
    name: "stats-participations",
    path: "/stats/participations",
    meta: participationsGtStzpHoz0TV07fjRq7A3InddIiEmrDPCRdrGadbahsMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/stats/participations.vue")
  },
  {
    name: "admin-settings-emails",
    path: "/admin/settings/emails",
    meta: emailsNh8I89HPI30q9fJ1SuKOhOaXdU6eqwxBC0VaAGzu6xwMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/settings/emails.vue")
  },
  {
    name: "profile-alertes",
    path: "/profile/alertes",
    meta: indexMx21hDe5hj6Pnt4M5CCgxwDBLPyC6_RcWyLc5imf_45R0Meta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/profile/alertes/index.vue")
  },
  {
    name: "profile-notifications",
    path: "/profile/notifications",
    meta: notificationsLMmq0FxCLVSUyPvW552rc_45xgxYrUOI9pZngjt5W4ptUMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/profile/notifications.vue")
  },
  {
    name: "admin-statistics",
    path: "/admin/statistics",
    meta: index05HIgPZeD1XMbI_VLQE2DDpbufFVF8hYzjQ73SbxQyMMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/statistics/index.vue")
  },
  {
    name: "charte-reserve-civique",
    path: "/charte-reserve-civique",
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/charte-reserve-civique.vue")
  },
  {
    name: "domaines-action-slug",
    path: "/domaines-action/:slug()",
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/domaines-action/[slug].vue")
  },
  {
    name: "messages-modeles",
    path: "/messages/modeles",
    meta: indexxN8RexZbTyVM_451_45t8S6huRu_45rejE8xVCqsYr3N0AeYMMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/messages/modeles/index.vue")
  },
  {
    name: "password-reset-token",
    path: "/password-reset/:token()",
    meta: _91token_93VJse0biQqRLCDJ4x0LzhhXTkxWto69dVFAr_kabawjAMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/password-reset/[token].vue")
  },
  {
    name: "quiz-decembre-ensemble",
    path: "/quiz/decembre-ensemble",
    meta: decembre_45ensemble7es9jDqmIWUwZl6Grx_45VDdXc3PchKkw2Awhm7_AebWcMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/quiz/decembre-ensemble.vue")
  },
  {
    name: "admin-other-invitations",
    path: "/admin/other/invitations",
    meta: invitationskxk5vUIOBQohonBV8trlYs5f_o6Wyoet0PCimr4VrOMMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/other/invitations.vue")
  },
  {
    name: "admin-settings-messages",
    path: "/admin/settings/messages",
    meta: messagesnTSswVZ4_45BrlUtaskKk_458l9VXmDhqswNpJw8EXQ72j0Meta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/settings/messages.vue")
  },
  {
    name: "admin-statistics-places",
    path: "/admin/statistics/places",
    meta: places7PZ1afKQ_8TlqcNRfMKqt6wdHcYVBqvyvd5yDqMBY_45cMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/statistics/places.vue")
  },
  {
    name: "admin-settings-rules-add",
    path: "/admin/settings/rules/add",
    meta: addn816hfiOzFZt2Ldn4LFAoCIHjYWGgprfU5ZLoa5X2hEMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/settings/rules/add.vue")
  },
  {
    name: "admin-utilisateurs",
    path: "/admin/utilisateurs",
    meta: indexd7boL_45p8oECzEvGX1dNnDFimmCkrg1fBiratXxiweswMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/utilisateurs/index.vue")
  },
  {
    name: "missions-benevolat",
    path: "/missions-benevolat",
    meta: indexd60p6nQ43Ijnc1g8Y4iX1KV1aFTsve908KZI4ZjxTSwMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/missions-benevolat/index.vue")
  },
  {
    name: "admin-missions-id-dates",
    path: "/admin/missions/:id()/dates",
    meta: dateslF42hHlRJYMJ8KXTxk0p1nSvl3L5ZAiiW3Af7taF9z4Meta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/missions/[id]/dates.vue")
  },
  {
    name: "admin-missions-id",
    path: "/admin/missions/:id()",
    meta: index0NxaC3MwL8y4OCPTTEi2HFaqmT4Fhi__45_V9fJO_45_45p6MMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/missions/[id]/index.vue")
  },
  {
    name: "admin-missions-id-lieux",
    path: "/admin/missions/:id()/lieux",
    meta: lieuxew50FW_Gg74SoaSfBcxY94fjqELjoD02bR6CoFVl9f8Meta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/missions/[id]/lieux.vue")
  },
  {
    name: "admin-missions-id-title",
    path: "/admin/missions/:id()/title",
    meta: titlei9fM1MXhEWJ0GcLHqjzGhCrEMTEBuZ6N2k2fR9M7xnoMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/missions/[id]/title.vue")
  },
  {
    name: "admin-organisations",
    path: "/admin/organisations",
    meta: indexha9RFttrcEeAJGnSrZGuXSRv2_bG8ub33JXAVJnBYCIMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/organisations/index.vue")
  },
  {
    name: "admin-statistics-missions",
    path: "/admin/statistics/missions",
    meta: missionshWKXKhW0zH3Tven8CZj2pB2reTWhzr2XvPuWtVEU_452kMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/statistics/missions.vue")
  },
  {
    name: "admin-contenus-reseaux-add",
    path: "/admin/contenus/reseaux/add",
    meta: addPEM_4576QojO9HAoTltR8XP0xhBs4NsPdwYkbs9qsCmvsMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/reseaux/add.vue")
  },
  {
    name: "admin-missions-id-visuel",
    path: "/admin/missions/:id()/visuel",
    meta: visuelxI7_fU3PUQVxDq_FveeLrKA5UaNSN80Pb2hfYNxjRCkMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/missions/[id]/visuel.vue")
  },
  {
    name: "admin-participations",
    path: "/admin/participations",
    meta: indexciyhAj7MEgIVJxlJBRPUMaNnxEjF9pJ61c0yi1WbRKMMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/participations/index.vue")
  },
  {
    name: "admin-settings-rules",
    path: "/admin/settings/rules",
    meta: indexP4UUAWPjz_kx_DFAWZiuXZZn_iffYhS_yKviJlj1mLgMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/settings/rules/index.vue")
  },
  {
    name: "inscription-benevole",
    path: "/inscription/benevole",
    meta: index87304XIGHyxXTHXZYOR70dvRpdeJQt92K8bkAGqBP10Meta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/inscription/benevole/index.vue")
  },
  {
    name: "admin-contenus-domaines-add",
    path: "/admin/contenus/domaines/add",
    meta: add396tO9fvrWnEgjSuvMuVFIxqeIL73ztX4KQdEdqSLEcMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/domaines/add.vue")
  },
  {
    name: "admin-taxonomies-slug-add",
    path: "/admin/taxonomies/:slug()/add",
    meta: add_hT5GnXWR1VdM8g6N2kCDiQEvhnSXo6NXzh5oNBYGWUMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/taxonomies/[slug]/add.vue")
  },
  {
    name: "admin-contenus-activites-add",
    path: "/admin/contenus/activites/add",
    meta: addBQzrgcWTNH_yltKpMlblaMONbDDb98wUeoSaT9ao3OIMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/activites/add.vue")
  },
  {
    name: "admin-contenus-reseaux",
    path: "/admin/contenus/reseaux",
    meta: indexT8NxA7JnCdcS6LOWCD_nqKvX7ynh5W_45DEwONO4QGZgMMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/reseaux/index.vue")
  },
  {
    name: "admin-statistics-conversions",
    path: "/admin/statistics/conversions",
    meta: conversionsKZp6NEVG9S8bLS9M14zCzfGV0SZ0Se8x86brBPfnnd8Meta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/statistics/conversions.vue")
  },
  {
    name: "admin-utilisateurs-id-edit",
    path: "/admin/utilisateurs/:id()/edit",
    meta: editojZZBRTLfdMzGnZ4Nr6O_45nBwiC61SfSCFx_45w6GvVGdAMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/utilisateurs/[id]/edit.vue")
  },
  {
    name: "politique-de-confidentialite",
    path: "/politique-de-confidentialite",
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/politique-de-confidentialite.vue")
  },
  {
    name: "admin-contenus-domaines",
    path: "/admin/contenus/domaines",
    meta: indexsG7X_45kSxTYJZbX345DZANKp8PHPjdGnUZRoR_3KQNXwMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/domaines/index.vue")
  },
  {
    name: "admin-contenus-ressources-add",
    path: "/admin/contenus/ressources/add",
    meta: add4FGoCnFUSxS2NfvcWdIsn7iEORAhG1hC8Qi7VCHUiNwMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/ressources/add.vue")
  },
  {
    name: "admin-missions-id-benevoles",
    path: "/admin/missions/:id()/benevoles",
    meta: benevolesJWRnMuI2zm7_45Sj1C4gpWwf9UY7Fllv1_gvk2TbPZN4kMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/missions/[id]/benevoles.vue")
  },
  {
    name: "admin-organisations-id-edit",
    path: "/admin/organisations/:id()/edit",
    meta: editxkpE_45jvSOWhpC43jtkQnej5kuv3Y5XupW_45GPnYAnOt0Meta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/organisations/[id]/edit.vue")
  },
  {
    name: "admin-statistics-utilisateurs",
    path: "/admin/statistics/utilisateurs",
    meta: utilisateurs1q8jaQhXZ9RvWOK_45sUkqSO1yF1lwYOARu_7fFGH_45iooMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/statistics/utilisateurs.vue")
  },
  {
    name: "admin-taxonomies-slug",
    path: "/admin/taxonomies/:slug()",
    meta: index_SuuiuGmv_We45JJJkjyK9CYTeSlWlzPj_rWgdWtXJUMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/taxonomies/[slug]/index.vue")
  },
  {
    name: "admin-utilisateurs-id",
    path: "/admin/utilisateurs/:id()",
    meta: indexrroORRt6Megfc2T4yCw7s6wfxjnAakcrd1HOQMkoWL8Meta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/utilisateurs/[id]/index.vue")
  },
  {
    name: "inscription-responsable",
    path: "/inscription/responsable",
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/inscription/responsable/index.vue")
  },
  {
    name: "missions-benevolat-id",
    path: "/missions-benevolat/:id()",
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/missions-benevolat/[id]/index.vue")
  },
  {
    name: "quiz-septembre-pour-apprendre",
    path: "/quiz/septembre-pour-apprendre",
    meta: septembre_45pour_45apprendredZUBnBt71xi9YnMf06cIRYMz8ZEhnSilF9y1QCOxHSUMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/quiz/septembre-pour-apprendre.vue")
  },
  {
    name: "admin-contenus-activites",
    path: "/admin/contenus/activites",
    meta: indexaWGzkQTCESgPbD_45BUsi4AnZzWuRicOvIlneIS3z6ACoMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/activites/index.vue")
  },
  {
    name: "admin-contenus-territoires-add",
    path: "/admin/contenus/territoires/add",
    meta: add5hLpmiwXhemusHWzv8hSEJ8gLqVX95_45pbRmTgkzuqk4Meta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/territoires/add.vue")
  },
  {
    name: "admin-organisations-id",
    path: "/admin/organisations/:id()",
    meta: indexLL7p_45Syw_45KNAaSM9yQye0VG2qoDt57ToyFZa_vGsCYAMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/organisations/[id]/index.vue")
  },
  {
    name: "admin-settings-rules-id-edit",
    path: "/admin/settings/rules/:id()/edit",
    meta: editcqPQ9KXEFFdc_lI3Ba2vyGQgioJmQM5oAcIyBd7mSUIMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/settings/rules/[id]/edit.vue")
  },
  {
    name: "missions-benevolat-id-slug",
    path: "/missions-benevolat/:id()/:slug()",
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/missions-benevolat/[id]/[slug].vue")
  },
  {
    name: "quiz-printemps-pour-la-planete",
    path: "/quiz/printemps-pour-la-planete",
    meta: printemps_45pour_45la_45planetemHa7aaDNi7vEfJkVadNwjBP9349zguq_45w_45xhf8xtchIMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/quiz/printemps-pour-la-planete.vue")
  },
  {
    name: "admin-contenus-ressources",
    path: "/admin/contenus/ressources",
    meta: indexAbdmxiE3L4_boWXffJBSMfIEb_xTiH3Dv_45moBzgVnIcMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/ressources/index.vue")
  },
  {
    name: "admin-statistics-participations",
    path: "/admin/statistics/participations",
    meta: participationsxkxFt9nrhxSdW9QJbj0oagFWUlM59o7DCXtNesXx2_gMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/statistics/participations.vue")
  },
  {
    name: "charte-bon-fonctionnement",
    path: "/charte-bon-fonctionnement",
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/charte-bon-fonctionnement/index.vue")
  },
  {
    name: "support-referents-activity-logs",
    path: "/support/referents/activity-logs",
    meta: activity_45logs42ZEPruLAp9CImWpSJosjiVGgkcPGNOzIbL5juYKEeAMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/support/referents/activity-logs.vue")
  },
  {
    name: "admin-contenus-reseaux-id-edit",
    path: "/admin/contenus/reseaux/:id()/edit",
    meta: editY0_I_tJuCrpgmSpR_qIAJ7bpqJzTWsrPL_6XOzYA488Meta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/reseaux/[id]/edit.vue")
  },
  {
    name: "admin-contenus-territoires",
    path: "/admin/contenus/territoires",
    meta: indexrHOT9xcrEN_45ryhWARQaRyjb_458qSQM_45VnU6fFDnY3VWkMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/territoires/index.vue")
  },
  {
    name: "admin-missions-id-informations",
    path: "/admin/missions/:id()/informations",
    meta: informationsVMPhaHkKvn_45DnvuRLquOFVXwwNzmG1XWKn1HjlzBgcAMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/missions/[id]/informations.vue")
  },
  {
    name: "admin-missions-id-responsables",
    path: "/admin/missions/:id()/responsables",
    meta: responsablesRE9hBVYN9T6jm9jzAoYTFL_45Isk_U_45eGxCLz8pNiq_452oMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/missions/[id]/responsables.vue")
  },
  {
    name: "admin-contenus-domaines-id-edit",
    path: "/admin/contenus/domaines/:id()/edit",
    meta: editBmjY4ZzV_45UFcpsIknhMh13QkFksgfila6lYboKoZWEMMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/domaines/[id]/edit.vue")
  },
  {
    name: "admin-contenus-reseaux-id",
    path: "/admin/contenus/reseaux/:id()",
    meta: indexqW8I_45ROSx6FgHwDxTyBT7Ly_45M4tELugiDuXEGZiDT5QMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/reseaux/[id]/index.vue")
  },
  {
    name: "admin-contenus-testimonials",
    path: "/admin/contenus/testimonials",
    meta: indexHw7AkVPOnBoJ_45lXfKzRZEZk4dXCKOTgGLx00FwqTRC4Meta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/testimonials/index.vue")
  },
  {
    name: "admin-statistics-indicateurs-cles",
    path: "/admin/statistics/indicateurs-cles",
    meta: indicateurs_45clesmKDJj4LbJ2Wn_9PR_8KpQd8BswcAoR_45wrJDPlds3McwMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/statistics/indicateurs-cles.vue")
  },
  {
    name: "admin-taxonomies-slug-id-edit",
    path: "/admin/taxonomies/:slug()/:id()/edit",
    meta: editaoxm9AGfxxhUVu5EaHhr864bhfmMfy_45tME_459E6FXBegMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/taxonomies/[slug]/[id]/edit.vue")
  },
  {
    name: "inscription-benevole-step-profile",
    path: "/inscription/benevole/step/profile",
    meta: profilemtNzuMIjBtwg_45MXiJzBb0DU0HyTnHXV7pNjXEyXCrOwMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/inscription/benevole/step/profile.vue")
  },
  {
    name: "profile-charte-bon-fonctionnement",
    path: "/profile/charte-bon-fonctionnement",
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/profile/charte-bon-fonctionnement.vue")
  },
  {
    name: "support-referents-waiting-actions",
    path: "/support/referents/waiting-actions",
    meta: waiting_45actionsSd_ThVrkTVNKgvmFNutlwrcqpZkKH2M7n2UwBA7veqsMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/support/referents/waiting-actions.vue")
  },
  {
    name: "admin-contenus-activites-id-edit",
    path: "/admin/contenus/activites/:id()/edit",
    meta: editPIBduzjZVcmaA8_d9Ps_yCU7PjseOSJ3gtjZy0gEBLgMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/activites/[id]/edit.vue")
  },
  {
    name: "admin-contenus-modeles-mission-add",
    path: "/admin/contenus/modeles-mission/add",
    meta: addxHtq_45eXB0wna2fwbgkDpRI0sNF7TimLicKSfpP1mTTgMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/modeles-mission/add.vue")
  },
  {
    name: "conditions-generales-d-utilisation",
    path: "/conditions-generales-d-utilisation",
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/conditions-generales-d-utilisation.vue")
  },
  {
    name: "admin-contenus-activites-id",
    path: "/admin/contenus/activites/:id()",
    meta: indexkx1sKS5tRH_45dwveFrOUgoHILyp7F8kvofU9UvWAbvXgMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/activites/[id]/index.vue")
  },
  {
    name: "admin-contenus-ressources-id-edit",
    path: "/admin/contenus/ressources/:id()/edit",
    meta: editkX58IZNYlaUfbOgXePPwE6ti_RJjy5K0RbJkjjWPa5QMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/ressources/[id]/edit.vue")
  },
  {
    name: "admin-organisations-id-diffusions",
    path: "/admin/organisations/:id()/diffusions",
    meta: diffusions_83o6URkb1zl2COz8qkrlOUaC2CK4keaFvm_5NlK9yoMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/organisations/[id]/diffusions.vue")
  },
  {
    name: "admin-statistics-suivis-moderations",
    path: "/admin/statistics/suivis/moderations",
    meta: moderations8BkXhiQZDW21n4AfjkqxlUC_yAAWFm6p35OKvhidjrEMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/statistics/suivis/moderations.vue")
  },
  {
    name: "charte-bon-fonctionnement-benevoles",
    path: "/charte-bon-fonctionnement/benevoles",
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/charte-bon-fonctionnement/benevoles.vue")
  },
  {
    name: "support-actions-google-api-indexing",
    path: "/support/actions/google-api-indexing",
    meta: google_45api_45indexingXl7AvDRxk10XclELaHEobDaX3Arz58HO25bIpETRIHQMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/support/actions/google-api-indexing.vue")
  },
  {
    name: "admin-contenus-modeles-mission",
    path: "/admin/contenus/modeles-mission",
    meta: indexZeLYClFHKnJcytadmOdkcSx4ONKrov9SpL6nQyXk9kgMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/modeles-mission/index.vue")
  },
  {
    name: "admin-contenus-territoires-id-edit",
    path: "/admin/contenus/territoires/:id()/edit",
    meta: editRWzdoDX90EpC2tVyzQ4RtFwVfbjJXuUgOn602VrcAgwMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/territoires/[id]/edit.vue")
  },
  {
    name: "admin-statistics-organisations",
    path: "/admin/statistics/organisations",
    meta: indext_Y2WocQKt6DQglu5b0W_45dJU3g0C1nRtpRORBU7Q6HgMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/statistics/organisations/index.vue")
  },
  {
    name: "inscription-responsable-step-profile",
    path: "/inscription/responsable/step/profile",
    meta: profileU0_Ep__45Hvl2LFZUOFUTlv2a7a4labeyEpedFFnfzQNIMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/inscription/responsable/step/profile.vue")
  },
  {
    name: "admin-contenus-territoires-id",
    path: "/admin/contenus/territoires/:id()",
    meta: indexsF86fwvO9TUrx7nSMZibnDuqjvKd2Xn4uTr6b9IQLGcMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/territoires/[id]/index.vue")
  },
  {
    name: "admin-contenus-testimonials-id-edit",
    path: "/admin/contenus/testimonials/:id()/edit",
    meta: editTq4JXvo0UpLH2n9h2gC5VUbAF8lr_hcNgXR52Pm_45vyMMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/testimonials/[id]/edit.vue")
  },
  {
    name: "admin-organisations-id-missions-add",
    path: "/admin/organisations/:id()/missions/add",
    meta: adde4iCsewqD5Vga5U6zT8SFY68uGdOXpyGva7EUYyuqRgMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/organisations/[id]/missions/add.vue")
  },
  {
    name: "inscription-benevole-step-competences",
    path: "/inscription/benevole/step/competences",
    meta: competencesV8TWNWopydQNK2rpppd4KX9HFmhjM4yrm37lBVmtUPsMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/inscription/benevole/step/competences.vue")
  },
  {
    name: "inscription-benevole-step-preferences",
    path: "/inscription/benevole/step/preferences",
    meta: preferencesxVbkGusNttmGBYnzBGbLIEldSaXW_4aruD1_45M6BFbvcMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/inscription/benevole/step/preferences.vue")
  },
  {
    name: "support-actions-search-archived-users",
    path: "/support/actions/search-archived-users",
    meta: search_45archived_45usersypgdFycA_b7pOxqL2C_45ynmVmCGkYdywxffsApNy8IgYMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/support/actions/search-archived-users.vue")
  },
  {
    name: "support-contents-doublons-territoires",
    path: "/support/contents/doublons-territoires",
    meta: doublons_45territoiresc2g_45FzPSHg8LKiPxp6acXmt9_tH5EnIWCrKDNUMP3BsMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/support/contents/doublons-territoires.vue")
  },
  {
    name: "charte-bon-fonctionnement-responsables",
    path: "/charte-bon-fonctionnement/responsables",
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/charte-bon-fonctionnement/responsables.vue")
  },
  {
    name: "support-actions-transfert-organisation",
    path: "/support/actions/transfert-organisation",
    meta: transfert_45organisation9UbMZM0E6erB_455bdldya_4567Qn_qoVZXsW2VHMkpCGAEMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/support/actions/transfert-organisation.vue")
  },
  {
    name: "support-responsables-missions-outdated",
    path: "/support/responsables/missions-outdated",
    meta: missions_45outdatedHTo6UIqv8_gHqS2wAX1LiTHFrbuKhOPIpzqJKwrAcWwMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/support/responsables/missions-outdated.vue")
  },
  {
    name: "admin-settings-rules-id-pending-items",
    path: "/admin/settings/rules/:id()/pending-items",
    meta: pending_45itemsRqKqWBqMBCW4j3fVYs_45ZxTRYWNYGqykq5Gwttb_9YAQMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/settings/rules/[id]/pending-items.vue")
  },
  {
    name: "support-actions-user-reset-context-role",
    path: "/support/actions/user-reset-context-role",
    meta: user_45reset_45context_45role7azn6qyLRXXo58h8KtIOXjec3OKqrCBpcdEr6SeuRs4Meta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/support/actions/user-reset-context-role.vue")
  },
  {
    name: "support-contents-doublons-organisations",
    path: "/support/contents/doublons-organisations",
    meta: doublons_45organisations_45_dul9Sv15uMs8t0qbDkmfUNQlLd8VqnEVS55bldvlYMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/support/contents/doublons-organisations.vue")
  },
  {
    name: "admin-contenus-modeles-mission-id-edit",
    path: "/admin/contenus/modeles-mission/:id()/edit",
    meta: edit5N4biuHg7EM9O6axSDxj5wZmeo201kINuBk9cYUv86oMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/modeles-mission/[id]/edit.vue")
  },
  {
    name: "inscription-benevole-step-disponibilites",
    path: "/inscription/benevole/step/disponibilites",
    meta: disponibilites35OXRtdhwvM9QKsMWqyzZZvKNdNFb4_SrEjyRUsui2sMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/inscription/benevole/step/disponibilites.vue")
  },
  {
    name: "support-actions-user-reset-password-link",
    path: "/support/actions/user-reset-password-link",
    meta: user_45reset_45password_45linkpWta_458H4xIzkq04t0eEBJisnSySB6L_QsdH3ZmwKAE8Meta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/support/actions/user-reset-password-link.vue")
  },
  {
    name: "admin-contenus-modeles-mission-id",
    path: "/admin/contenus/modeles-mission/:id()",
    meta: index_MNXNvkrpkK_45V7euwrSQshYbku9tRLJ4FszMBDEBc2QMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/contenus/modeles-mission/[id]/index.vue")
  },
  {
    name: "inscription-responsable-step-collectivite",
    path: "/inscription/responsable/step/collectivite",
    meta: collectivitexMvTOV3eijcQw_UkBDhgSycKv6KqNZZYhRbF5iCSIDIMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/inscription/responsable/step/collectivite.vue")
  },
  {
    name: "inscription-responsable-step-organisation",
    path: "/inscription/responsable/step/organisation",
    meta: organisation9jT5GSfts3uusjt8HmfTWI3d78b2_qp3NFseU58ue9oMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/inscription/responsable/step/organisation.vue")
  },
  {
    name: "admin-missions-id-benevoles-informations",
    path: "/admin/missions/:id()/benevoles-informations",
    meta: benevoles_45informationsS3wctyIGoEv4CuFCr6G8OrP2S1EFG9i9m4J4F71TXcUMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/missions/[id]/benevoles-informations.vue")
  },
  {
    name: "admin-statistics-api-engagement-trafic-entrant",
    path: "/admin/statistics/api-engagement/trafic-entrant",
    meta: trafic_45entrantwzTgawCmOjSVPnUwvwD3z2THtFwbeVaHwSqJOVfKeh0Meta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/statistics/api-engagement/trafic-entrant.vue")
  },
  {
    name: "admin-statistics-api-engagement-trafic-sortant",
    path: "/admin/statistics/api-engagement/trafic-sortant",
    meta: trafic_45sortantcyOjMZ6_45LmZy9xncq79x39miPhvAe_riOkTop0f08A4Meta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/statistics/api-engagement/trafic-sortant.vue")
  },
  {
    name: "admin-missions-id-trouver-des-benevoles",
    path: "/admin/missions/:id()/trouver-des-benevoles",
    meta: indexqJR4ZYleIQxIXbDvYk7PIzoN3hyjOemuixJJDtH63hMMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/missions/[id]/trouver-des-benevoles/index.vue")
  },
  {
    name: "admin-statistics-departements-missions-perimees",
    path: "/admin/statistics/departements/missions-perimees",
    meta: missions_45perimeesoU_45KRw4WxNo7HsbT689nGcRUNjw9T9raSEIX7bcLoMYMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/statistics/departements/missions-perimees.vue")
  },
  {
    name: "admin-statistics-departements-missions-a-valider",
    path: "/admin/statistics/departements/missions-a-valider",
    meta: missions_45a_45valider2N8ThHP2JBgVcddgPbk6gjihBZkI_45jMoJ6EQVIyPrJUMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/statistics/departements/missions-a-valider.vue")
  },
  {
    name: "admin-statistics-organisations-missions-perimees",
    path: "/admin/statistics/organisations/missions-perimees",
    meta: missions_45perimeesiOs5diL9OsP9IeLjdS1Wf0Zgw5VSwqmuvuu3BwlpDcYMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/statistics/organisations/missions-perimees.vue")
  },
  {
    name: "inscription-responsable-step-organisation-images",
    path: "/inscription/responsable/step/organisation-images",
    meta: organisation_45imagese5Vw583atV_ph1TQCwNXwvda5nl0E5VAyFoe4rc2waUMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/inscription/responsable/step/organisation-images.vue")
  },
  {
    name: "inscription-responsable-step-organisation-details",
    path: "/inscription/responsable/step/organisation-details",
    meta: organisation_45detailsfZbRhj5h25eyZI3tTSCEVR9J2yERqaFQHbb2xvQV6jgMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/inscription/responsable/step/organisation-details.vue")
  },
  {
    name: "support-responsables-participations-to-be-treated",
    path: "/support/responsables/participations-to-be-treated",
    meta: participations_45to_45be_45treatedhq6PfO1w_45UVcdzwugTZAA6RKSQ8ZdHq7oJYyd6_456_B8Meta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/support/responsables/participations-to-be-treated.vue")
  },
  {
    name: "admin-missions-id-trouver-des-benevoles-redirect",
    path: "/admin/missions/:id()/trouver-des-benevoles/redirect",
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/missions/[id]/trouver-des-benevoles/redirect.vue")
  },
  {
    name: "admin-statistics-departements-organisations-a-valider",
    path: "/admin/statistics/departements/organisations-a-valider",
    meta: organisations_45a_45validerjXIvQOzT7JFzFPyy9vMgmnNBkLWp_45_ZXVku1vr0zb7oMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/statistics/departements/organisations-a-valider.vue")
  },
  {
    name: "inscription-responsable-step-charte-bon-fonctionnement",
    path: "/inscription/responsable/step/charte-bon-fonctionnement",
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/inscription/responsable/step/charte-bon-fonctionnement.vue")
  },
  {
    name: "inscription-responsable-step-collectivite-confirmation",
    path: "/inscription/responsable/step/collectivite-confirmation",
    meta: collectivite_45confirmationkxsl_DI4GnWWYkG95_TsZpwT5c3O91hXTVCinFjK0fcMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/inscription/responsable/step/collectivite-confirmation.vue")
  },
  {
    name: "inscription-responsable-step-organisation-confirmation",
    path: "/inscription/responsable/step/organisation-confirmation",
    meta: organisation_45confirmationcgaUVwxXgUuqIgpNce_45vKlDxu1DxclgyxlXoz17U3bgMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/inscription/responsable/step/organisation-confirmation.vue")
  },
  {
    name: "admin-statistics-organisations-participations-a-valider",
    path: "/admin/statistics/organisations/participations-a-valider",
    meta: participations_45a_45valider6nlUKsE6JDwE_45FLBu7TjFvAI_45mQddGruL66_tzSZGeQMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/statistics/organisations/participations-a-valider.vue")
  },
  {
    name: "admin-statistics-organisations-participations-refusees-annulees",
    path: "/admin/statistics/organisations/participations-refusees-annulees",
    meta: participations_45refusees_45annuleesrlVY2Z7G1kD6loWnMdqYYyBsQVVSoplikesPKN2EW5YMeta || {},
    component: () => import("/build/4f0ad69f-c1f7-4cba-9855-c16ded97805c/pages/admin/statistics/organisations/participations-refusees-annulees.vue")
  },
  {
    name: component_45stub32ei5Lp6kKFMxeAtTr0nOthwUtOReReQnZ7RRfSB07IMeta?.name,
    path: "/register/volontaire/:pathMatch(.*)",
    component: component_45stub32ei5Lp6kKFMxeAtTr0nOthwUtOReReQnZ7RRfSB07I
  },
  {
    name: component_45stub32ei5Lp6kKFMxeAtTr0nOthwUtOReReQnZ7RRfSB07IMeta?.name,
    path: "/register/responsable/:pathMatch(.*)",
    component: component_45stub32ei5Lp6kKFMxeAtTr0nOthwUtOReReQnZ7RRfSB07I
  },
  {
    name: component_45stub32ei5Lp6kKFMxeAtTr0nOthwUtOReReQnZ7RRfSB07IMeta?.name,
    path: "/user/settings",
    component: component_45stub32ei5Lp6kKFMxeAtTr0nOthwUtOReReQnZ7RRfSB07I
  },
  {
    name: component_45stub32ei5Lp6kKFMxeAtTr0nOthwUtOReReQnZ7RRfSB07IMeta?.name,
    path: "/user/:pathMatch(.*)",
    component: component_45stub32ei5Lp6kKFMxeAtTr0nOthwUtOReReQnZ7RRfSB07I
  },
  {
    name: component_45stub32ei5Lp6kKFMxeAtTr0nOthwUtOReReQnZ7RRfSB07IMeta?.name,
    path: "/dashboard/structure/:pathMatch(.*)",
    component: component_45stub32ei5Lp6kKFMxeAtTr0nOthwUtOReReQnZ7RRfSB07I
  },
  {
    name: component_45stub32ei5Lp6kKFMxeAtTr0nOthwUtOReReQnZ7RRfSB07IMeta?.name,
    path: "/dashboard/mission/:pathMatch(.*)",
    component: component_45stub32ei5Lp6kKFMxeAtTr0nOthwUtOReReQnZ7RRfSB07I
  },
  {
    name: component_45stub32ei5Lp6kKFMxeAtTr0nOthwUtOReReQnZ7RRfSB07IMeta?.name,
    path: "/dashboard/participation/:pathMatch(.*)",
    component: component_45stub32ei5Lp6kKFMxeAtTr0nOthwUtOReReQnZ7RRfSB07I
  },
  {
    name: component_45stub32ei5Lp6kKFMxeAtTr0nOthwUtOReReQnZ7RRfSB07IMeta?.name,
    path: "/dashboard/profile/:pathMatch(.*)",
    component: component_45stub32ei5Lp6kKFMxeAtTr0nOthwUtOReReQnZ7RRfSB07I
  },
  {
    name: component_45stub32ei5Lp6kKFMxeAtTr0nOthwUtOReReQnZ7RRfSB07IMeta?.name,
    path: "/dashboard/reseaux/:pathMatch(.*)",
    component: component_45stub32ei5Lp6kKFMxeAtTr0nOthwUtOReReQnZ7RRfSB07I
  },
  {
    name: component_45stub32ei5Lp6kKFMxeAtTr0nOthwUtOReReQnZ7RRfSB07IMeta?.name,
    path: "/inscription/organisation",
    component: component_45stub32ei5Lp6kKFMxeAtTr0nOthwUtOReReQnZ7RRfSB07I
  },
  {
    name: component_45stub32ei5Lp6kKFMxeAtTr0nOthwUtOReReQnZ7RRfSB07IMeta?.name,
    path: "/statistiques",
    component: component_45stub32ei5Lp6kKFMxeAtTr0nOthwUtOReReQnZ7RRfSB07I
  },
  {
    name: component_45stub32ei5Lp6kKFMxeAtTr0nOthwUtOReReQnZ7RRfSB07IMeta?.name,
    path: "/activites/accompagnement-aux-activites-sportives",
    component: component_45stub32ei5Lp6kKFMxeAtTr0nOthwUtOReReQnZ7RRfSB07I
  },
  {
    name: component_45stub32ei5Lp6kKFMxeAtTr0nOthwUtOReReQnZ7RRfSB07IMeta?.name,
    path: "/sitemap.xml",
    component: component_45stub32ei5Lp6kKFMxeAtTr0nOthwUtOReReQnZ7RRfSB07I
  }
]